import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
import { q1O } from '../util/nE';
import imagesLoaded from 'imagesloaded';
import state from '../state';
gsap.registerPlugin(SplitText);

class HeroMedia {
  constructor(el) {
    this.el = el;
    this.title = this.el.querySelector('.hero-media__title');
    this.cta = this.el.querySelector('.hero-media__cta');
    this.imageWrapper = this.el.querySelector('.hero-media__wrapper');
    this.image = this.el.querySelector('.c-media');
    this.emded = this.el.querySelector('.embed');
    this.closeModal = this.el.querySelector('.btn--close');
    this.embedBlank = this.el.querySelector('.embed__blank');
    this.text = this.el.querySelector('.hero-media__text');
    this.notFoundContent = this.el.querySelector('.not-found-content');
  }

  init() {
    this.buildSplitText();
   //  this.preloadAssets();
    this.buildTimelineIn();
    this.bindModalOpen();
  }

//   preloadAssets() {
//     const imagesLoadedPromise = new Promise((resolve, reject) => {
//       const imgLoad = imagesLoaded(this.el);
//       imgLoad.on('done', () => {
//         resolve();
//       });
//     });

//     const preloadVideos = () => {
//       const promises = [];
//       const video = this.el.querySelector('video');

//       gsap.utils.toArray(video).forEach(video => {
//         promises.push(
//           new Promise((resolve, reject) => {
//             video.load();
//             video.addEventListener('loadeddata', () => {
//               const playPromise = video.play();
//               if (playPromise !== undefined) {
//                 playPromise
//                   .then(() => {
//                     resolve();
//                   })
//                   .catch(error => {
//                     reject(error);
//                   });
//               } else {
//                 console.log('playPromise is undefined');
//                 resolve();
//               }
//             });
//             video.addEventListener('error', error => {
//               reject(error);
//             });
//           })
//         );
//       });

//       return Promise.all(promises);
//     };

//     Promise.all([imagesLoadedPromise, preloadVideos()])
//       .then(() => {
//         this.buildTimelineIn();
//       })
//       .catch(error => {
//         console.error(error);
//       });
//   }

  buildSplitText() {
    if (!this.title) {
      return;
    }

    this.split = new SplitText(this.title, {
      type: 'chars, words, lines',
      linesClass: 's-line u-t overflow-hidden',
      lineThreshold: 0.9,
    });
  }

  buildTimelineIn() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
      },
      defaults: {
        ease: t => {
          return q1O(t);
        },
        duration: 1,
      },
    });

    tl.set(this.el, { autoAlpha: 1 });

    if (this.split) {
      tl.fromTo(
        this.split.chars,
        {
          yPercent: 100,
          autoAlpha: 0,
        },
        {
          yPercent: 0,
          autoAlpha: 1,
          stagger: 0.03,
          duration: .75,
        },
        0.1
      );
    }

    tl.to(
      this.imageWrapper,
      {
        clipPath: 'inset(0% round 8px)',
        duration: 1.1,
        ease: t => {
          return q1O(t);
        },
      },
      0
    );

    tl.to(
      this.image,
      {
        scale: 1,
        duration: 1.1,
        ease: t => {
          return q1O(t);
        },
      },
      0
    );

    if (this.cta) {
      tl.from(
        this.cta,
        {
          y: 100,
          autoAlpha: 0,
          duration: .7,
        },
        0.4
      );
    }

    if (this.text) {
      tl.from(
        this.text,
        {
          y: 100,
          autoAlpha: 0,
          duration: 1,
        },
        0.4
      );
    }

    if (this.notFoundContent) {
      const inners = this.notFoundContent.querySelectorAll('.js-in');
      tl.set(this.notFoundContent, { autoAlpha: 1 }, 0);
      tl.fromTo(
        inners,
        {
          y: 100,
          autoAlpha: 0,
          duration: 1.5,
        },
        {
          y: 0,
          autoAlpha: 1,
          duration: 1.5,
          stagger: 0.1,
        },
        0.1
      );
    }
  }

  bindModalOpen() {
    if (!this.emded) {
      return;
    }

    const closeAnimation = () => {
      gsap.to(this.emded, {
        autoAlpha: 0,
        duration: 0.6,
        ease: t => q1O(t),
      });

      if (state.cursor) {
        state.cursor.onCursorShow(this.el);
      }
    };

    this.imageWrapper.addEventListener('click', () => {
      gsap.to(this.emded, {
        autoAlpha: 1,
        duration: 0.6,
        ease: t => {
          return q1O(t);
        },
      });

      if (state.cursor) {
        state.cursor.onCursorHide();
      }
    });

    this.closeModal.addEventListener('click', () => {
      closeAnimation();
    });

    this.embedBlank.addEventListener('click', () => {
      closeAnimation();
    });
  }

  destroy() {}
}

export default HeroMedia;



//////////////////
// WEBPACK FOOTER
// ./scripts/components/HeroMedia.js
// module id = 47
// module chunks = 0